import React, { useState } from 'react'
import Modal from '@elements/Modal'
import LoginModalEmail from './components/LoginModalEmail'
import LoginModalPassword from './components/LoginModalPassword'
import LoginModalForgotPassword from './components/LoginModalForgotPassword'
import { ReactComponent as CloseIcon } from '@images/icon-close.svg'
import { CloseHeader } from './styles'
import { LoginModalSignup } from './components/LoginModalSignup'

export enum STATES {
  'EMAIL',
  'PASSWORD',
  'FORGOT_PASSWORD',
  'SIGNUP'
}

type LoginModalProps = {
  onClose: () => void
}

const LoginModal: React.FC<LoginModalProps> = ({ onClose }) => {
  const [transitionState, updateState] = useState<STATES>(STATES.EMAIL)
  const [formState, setFormState] = useState({ email: '', password: '' })

  return (
    <Modal>
      <CloseHeader>
        <CloseIcon data-testid="modal-close" onClick={onClose} />
      </CloseHeader>
      {transitionState === STATES.SIGNUP && (
        <LoginModalSignup
          email={formState.email}
          transition={() => {
            updateState(STATES.EMAIL)
          }}
          onClose={onClose}
        />
      )}

      {transitionState === STATES.EMAIL && (
        <LoginModalEmail
          transition={(email, state = STATES.PASSWORD) => {
            updateState(state)
            setFormState({ email, password: '' })
          }}
        />
      )}
      {transitionState === STATES.PASSWORD && (
        <LoginModalPassword
          email={formState.email}
          transition={() => {
            updateState(STATES.FORGOT_PASSWORD)
          }}
          onClose={onClose}
        />
      )}
      {transitionState === STATES.FORGOT_PASSWORD && (
        <LoginModalForgotPassword
          email={formState.email}
          transition={() => {
            updateState(STATES.EMAIL)
          }}
        />
      )}
    </Modal>
  )
}

export default LoginModal
